import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  text: {
    marginBottom: theme.spacing(3),
    "& > strong": {
      fontWeight: 700
    }
  }
}));

const Paragraph = ({ text }) => {
  const classes = useStyles();

  return (
    <Box mb={2}>
      {text && text.split('\n').map((child, key) => {
        const childProps = child.indexOf('</') > -1 
          ? { dangerouslySetInnerHTML:{__html: child } } 
          : { children: child };

        return (
          <Typography 
            variant="body1"
            key={key}
            component="p"
            color="textPrimary"
            className={classes.text}
            {...childProps}
            >
          </Typography>
        )
      })}
    </Box>
  );
};

export default Paragraph;